export default __webpack_public_path__ + "static/media/transition-1.62848c04.mp3";